<div class="body-bg-top">
</div>
<div
  class="container-fluid"
  style="background-color: #f7f9fc;"
>
  <div class="container position-relative">
    <app-home-banner-slider></app-home-banner-slider>
    <div class="news">
      <div style="margin-top: 28px"
        class="section-header d-flex align-items-center mb-3 justify-content-between"
      >
        <h3 class="section-title" style="font-size: 24px;">{{ ("services" | translate) | uppercase }}</h3>
      </div>
      <div class="cards-wrapper">
      <div class="card-wrapper"
              (click)="onInsuranceProviderDoctorBubbleClick()"
            >
              <img style="width: 52px; height: 58px" src="assets/card-icons/new/tbc-logo.svg" alt="">
              <div>
              <h6 class="card-text">
                {{ "tbc-insurance-doctors" | translate }}
              </h6>
              <small class="card-text-bottom">{{
                "video-consultation" | translate
              }}</small>
              </div>
              <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">
            </div>

      <div class="card-wrapper"
      [queryParams]="{ online: true }"
      routerLink="/search-step"
            >
              <img style="width: 52px; height: 58px" src="assets/card-icons/new/video_call_card.svg" alt="">
              <div>
              <h6 class="card-text">
                {{ "doctor-online-consultation" | translate }}
              </h6>
              <small class="card-text-bottom">{{ "300-specialists" | translate | shortenText: 25}}</small>
            </div>
            <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

          </div>
          
          <div
          class="card-wrapper"
          (click)="goToClinicWeb()"
        >
          <img style="width: 52px; height: 58px" src="assets/card-icons/new/clinic-visit-card.svg" alt="">
          <div>
          <h6 class="card-text">
            {{ "book-a-visit-to-the-clinic" | translate }}
          </h6>
          <small class="card-text-bottom">{{
            "30-clinics-300-doctors" | translate | shortenText: 25
          }}</small>
        </div>
        <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

        </div>

        <div
        class="card-wrapper"
        [queryParams]="{ serviceType: 2 }"
        routerLink="/search-step"
      >
        <img style="width: 52px; height: 58px" src="assets/card-icons/new/home_visit_card.svg" alt="">
        <div>
        <h6 class="card-text">
          {{ "doctor-at-home" | translate }}
        </h6>
        <small class="card-text-bottom">{{ "pediatrician-therapist" | translate | shortenText: 25}}</small>
      </div>
      <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">
  
      </div>

        <div
        class="card-wrapper"
        (click)="goToNurseAtHome()"
      >
        <div class="nurse-at-home-new-wrapper">
          <img style="width: 52px; height: 58px" src="assets/card-icons/new/Home_Visit_Nurse.png" alt="">
          <p>{{ 'new' | translate | uppercase}}</p>
        </div>
        <div>
        <h6 class="card-text">
          {{ "nurse-at-home" | translate }}
        </h6>
        <small class="card-text-bottom">{{ "book-nurse-at-home" | translate | shortenText: 25}}</small>
      </div>
      <p style="display: none;" class="new-icon">{{ 'new' | translate | uppercase}} ></p>

      </div>

        <div
        class="card-wrapper"
        (click)="goToClinicWeb('lab')"
      >
        <img style="width: 52px; height: 58px" src="assets/card-icons/new/laboratory_card.svg" alt="">
        <div>
        <h6 class="card-text">
          {{ "laboratory-tests" | translate }}
        </h6>
        <small class="card-text-bottom">{{ "house-or-lab" | translate | shortenText: 25}}</small>
      </div>
      <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

      </div>

    <div
    class="card-wrapper"
    [queryParams]="{ serviceType: 1, foreign: true }"
    routerLink="/search"
  >
    <img style="width: 52px; height: 58px" src="assets/card-icons/new/doctor_card.svg" alt="">
    <div>
    <h6 class="card-text">
      {{ "doctors-abroad" | translate }}
    </h6>
    <small class="card-text-bottom">{{
      "secondary-opinion" | translate | shortenText: 25
    }}</small>
  </div>
  <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

  </div>




  </div>            
      <!-- <swiper
        [breakpoints]="newsConfig.breakpoints"
        [navigation]="newsNav"
        [pagination]="newsPagination"
        [spaceBetween]="24"
        class="swiper-container m-0 newsSwiper"
        style="border: 1px solid #c0c5cc; border-radius: 20px"
      >
        <div class="swiper-wrapper">
          <ng-template swiperSlide>
            <div
              class="news-card-new swiper-slide m-0"
              (click)="onInsuranceProviderDoctorBubbleClick()"
            >
              <div
                [inlineSVG]="'assets/card-icons/new/insurance_doctor_card.svg'"
              ></div>
              <h6 class="uppercase">
                {{ "insurance-provider-doctors" | translate }}
              </h6>
              <small>{{
                "book-a-visit-to-insurance-provider-doctors" | translate
              }}</small>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div
              [queryParams]="{ online: true }"
              class="news-card-new swiper-slide m-0"
              routerLink="/search-step"
            >
              <div
                [inlineSVG]="'assets/card-icons/new/video_call_card.svg'"
              ></div>
              <h6 class="uppercase">
                {{ "doctor's-consultation" | translate }}
              </h6>
              <small>{{ "sign-up-for-online-consultation" | translate }}</small>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div
              class="news-card-new swiper-slide m-0"
              (click)="goToClinicWeb()"
            >
              <div
                [inlineSVG]="'assets/card-icons/new/clinic-visit-card.svg'"
              ></div>
              <h6 class="uppercase">
                {{ "registration-in-the-clinic" | translate }}
              </h6>
              <small>{{
                "book-a-clinic-or-lab-appointment" | translate
              }}</small>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div
              class="news-card-new swiper-slide m-0"
              (click)="goToClinicWeb('lab')"
            >
              <div
                [inlineSVG]="'assets/card-icons/new/laboratory_card.svg'"
              ></div>
              <h6 class="uppercase">{{ "lab-analyses" | translate }}</h6>
              <small>{{ "book-laboratory-services" | translate }}</small>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div
              class="news-card-new swiper-slide m-0"
              [queryParams]="{ serviceType: 2 }"
              routerLink="/search-step"
            >
              <div
                [inlineSVG]="'assets/card-icons/new/home_visit_card.svg'"
              ></div>
              <h6 class="uppercase">{{ "doctor-at-home" | translate }}</h6>
              <small>{{ "call-the-doctor-at-home" | translate }}</small>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div
              [queryParams]="{ serviceType: 1, foreign: true }"
              class="news-card-new swiper-slide m-0"
              routerLink="/search"
            >
              <div [inlineSVG]="'assets/card-icons/new/doctor_card.svg'"></div>
              <h6 class="uppercase">{{ "secondary-opinion" | translate }}</h6>
              <small>{{
                "sign-up-for-a-video-consultation" | translate
              }}</small>
            </div>
          </ng-template>

        </div>
      </swiper> -->
    </div>


    

    <div *ngIf="popularClinics.length" class="popular-clinics">
      <h3 class="section-title desktop" style="margin-bottom: 20px; font-size: 24px; margin-top: 28px">{{ "clinics" | translate | uppercase }}</h3>
      <div
      style="margin-bottom: 22px;"
        class="section-header d-flex align-items-center justify-content-between desktop"
      >
        <p class="clinic-length">{{ 'available' | translate}} {{clinicsLength}} {{ 'clinic' | translate}}</p>
        <div class="d-flex align-items-center">
          <a class="seeAll" (click)="goToCompany()">{{
            "see-all" | translate
          }}</a>
          <div class="pagination"></div>
          <button class="new-prev" mat-icon-button>
            <mat-icon>west</mat-icon>
          </button>
          <button class="new-next" mat-icon-button>
            <mat-icon>east</mat-icon>
          </button>
        </div>
      </div>
      <div
      class="section-header d-flex align-items-center justify-content-between mobile "
        >
        <h3 class="section-title" >{{ "clinics" | translate | uppercase}}</h3>
          <p class="clinic-length">{{clinicsLength}} {{ "clinic" | translate }}</p>
      </div>

      <div class="row">
        <!-- <div class="col-4 d-none d-md-block">
          <div class="hospital-building">
            <div class="position-relative" style="top: 25%">
              <h3>30+ {{ "clinic" | translate }}</h3>
              <p>
                {{
                  "by-redmed,-you-can-book-online-the-various-services-of-30+-clinics"
                    | translate
                }}
              </p>
            </div>
          </div>
        </div> -->
        <div class="" style="width: 100%;">
          <swiper
            [breakpoints]="popularClinicsConfig.breakpoints"
            [lazy]="true"
            [navigation]="popularClinicsNav"
            [pagination]="popularClinicsPagination"
            [preloadImages]="false"
            [spaceBetween]="24"
            class="swiper-container m-0"
          > 
          <div class="swiper-wrapper" *ngIf="clinicListSize < 5 && isDesktop">
            <ng-container *ngFor="let clinic of popularClinics; let i = index">

              <ng-template swiperSlide class="swipper-classs">
                <div [ngClass]="{'second-item': i !== 0}" class="clinic-container" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 12px;">
                  
                  <div class="swiper-slide m-0 cursor-pointer clinic-box" (click)="goToCompany(clinic[0].id)"
                    style="display: flex; align-items: center; justify-content: center; background-repeat: no-repeat; background-position: center; background-size: contain;
                    background-color: #FFFFFF; border: 0.5px solid #C0C5CC; border-radius: 72.25px; width: 268px; height: 90px;">
                    <img class="clinic-logo" style="border-radius: 50%; width: 68.77px; height: 68.77px; object-fit: contain;"
                    [src]="url + '/companies/' + clinic[0].id + '/logo'">
                    <h1 class="clinic-name">{{ clinic[0].name | shortenText: 38 }}</h1>
                  </div>
            
                  <div *ngIf="clinic[1]" class="swiper-slide m-0 cursor-pointer clinic-box" (click)="goToCompany(clinic[1].id)"
                    style="display: flex; align-items: center; justify-content: center; background-repeat: no-repeat; background-position: center; background-size: contain;
                    background-color: #FFFFFF; border: 0.5px solid #C0C5CC; border-radius: 72.25px; width: 268px; height: 90px;">
                    <img class="clinic-logo" style="border-radius: 50%; width: 68.77px; height: 68.77px; object-fit: contain;"
                    [src]="url + '/companies/' + clinic[1].id + '/logo'">
                    <h1 class="clinic-name">{{ clinic[1].name | shortenText: 38 }}</h1>
                  </div>   
                </div>
              </ng-template>
            </ng-container>
          </div>
            <div class="swiper-wrapper" *ngIf="clinicListSize > 4 || !isDesktop">
              <ng-container *ngFor="let clinic of popularClinics">

                <ng-template swiperSlide class="swipper-class">
                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px;">
                    <div class="swiper-slide m-0 cursor-pointer" (click)="goToCompany(clinic[0].id)"
                        style="display: flex; align-items: center; justify-content: center; background-repeat: no-repeat; background-position: center; background-size: contain;
                        background-color: #FFFFFF; border: 0.5px solid #C0C5CC; border-radius: 72.25px; width: 268px; height: 90px;"
                    >
                      <img style="border-radius: 50%; width: 68.77px; height: 68.77px; object-fit: contain;"
                      [src]="url + '/companies/' + clinic[0].id + '/logo'">
                      <h1 class="clinic-name"
                      >{{clinic[0].name | shortenText: 38}}</h1>
                    </div>
  
                    <div *ngIf="clinic[1]" class="swiper-slide m-0 cursor-pointer" (click)="goToCompany(clinic[1].id)"
                        style="display: flex; align-items: center; justify-content: center; background-repeat: no-repeat; background-position: center; background-size: contain;
                        background-color: #FFFFFF; border: 0.5px solid #C0C5CC; border-radius: 72.25px; width: 268px; height: 90px;"
                      >
                      <img style="border-radius: 50%; width: 68.77px; height: 68.77px; object-fit: contain;"
                      [src]="url + '/companies/' + clinic[1].id + '/logo'">
                      <h1 class="clinic-name"
                      >{{clinic[1].name | shortenText: 38}}</h1>
                    </div>
  
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </swiper>
        </div>
      </div>
      <a  class="seeAllMobile mobile" (click)="goToCompany()">{{
        "see-all" | translate
      }}</a>
    </div>

    <div *ngIf="allDoctors$ | async as allDoctors"  class="popular-doctors"> 
      <h3 class="section-title desktop" style="margin-bottom: 20px; font-size: 24px; margin-top: 28px">{{ "doctors" | translate | uppercase}}</h3>
      <div
      style="margin-bottom: 22px;"
        class="section-header d-flex align-items-center justify-content-between desktop"
      >
      <p class="clinic-length">{{'available' | translate | lowercase}} {{allActiveDoctors}} {{'doctor' | translate | lowercase}}</p>
        <div class="d-flex align-items-center">
          <!-- <a class="seeAll" (click)="goToCompany()">{{
            "see-all" | translate
          }}</a> -->
          <div class="pagination"></div>
          <button class="new-prev" mat-icon-button>
            <mat-icon>west</mat-icon>
          </button>
          <button class="new-next" mat-icon-button>
            <mat-icon>east</mat-icon>
          </button>
        </div>
      </div>
      <div
      class="section-header d-flex align-items-center justify-content-between mobile "
        >
        <h3 class="section-title" >{{ "doctors" | translate | uppercase}}</h3>
          <p class="clinic-length">{{allActiveDoctors}} {{ "doctor" | translate }}</p>
      </div>
      <swiper
        [breakpoints]="popularDoctorsConfig.breakpoints"
        [lazy]="true"
        [navigation]="popularDoctorsNav"
        [pagination]="popularDoctorsPagination"
        [preloadImages]="false"
        [spaceBetween]="24"
        class="swiper-container doctors"
      >       

        <div class="swiper-wrapper">
          <ng-template *ngFor="let doctor of popularDoctors" swiperSlide>
            <app-popular-doctor [isFromMainPage]="true" [doctor]="doctor"></app-popular-doctor>
          </ng-template>
        </div>
      </swiper>
      <!-- <a class="seeAllMobile mobile" routerLink="/search">{{
        "see-all" | translate
      }}</a> -->
    </div>

    <div class="how-it-works" id="how-it-works-main-section">
      <!-- id არ უნდა შეიცვალოს footer_ში არის გაწერილი, რომ აქ ამოისქროლოს -->
      <div class="row">
        <div class="col-lg-8 col-sm-12 text-center">
          <div class="ml-3">
            <h1 class="font-weight-bold section-title text-left">
              {{ "howItWorks" | translate }}
            </h1>
            <p class="text-left">
              {{ "read-the-instructions-for-use-of-redmed" | translate }}
              <br />
              {{ "and-book-the-desired-service-easily." | translate }}
            </p>
            <img src="assets/icons/how-it-works.png" alt="" />
          </div>
        </div>
        <div class="col-lg-4 col-sm-12">
          <div class="no-gutters">
            <div class="">
              <div class="how-it-works-card d-flex mb-lg-0 mb-3">
                <span
                  [inlineSVG]="'assets/img/level-1.svg'"
                  class="icon"
                ></span>
                <div>
                  <h6 class="font-14 font-weight-bold uppercase">
                    {{ "chooseTheDirection" | translate }}
                  </h6>
                  <p class="mb-0 font-13">
                    {{ "chooseTheDirectionYouNeed" | translate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="">
              <div class="how-it-works-card d-flex mb-lg-0 mb-3">
                <span
                  [inlineSVG]="'assets/img/level-2.svg'"
                  class="icon"
                ></span>
                <div>
                  <h6 class="font-14 font-weight-bold uppercase">
                    {{ "chooseADoctor" | translate }}
                  </h6>
                  <p class="mb-0 font-13">
                    {{
                      "reviewYourDoctorsProfileAndRatingsLeftByOtherUsers"
                        | translate
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="">
              <div class="how-it-works-card d-flex mb-lg-0 mb-3">
                <span
                  [inlineSVG]="'assets/img/level-3.svg'"
                  class="icon"
                ></span>
                <div>
                  <h6 class="font-14 font-weight-bold uppercase">
                    {{ "chooseAService" | translate }}
                  </h6>
                  <p class="mb-0 font-13">
                    {{ "specifyTheTypeTimeAndPlaceOfService" | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="blog" *ngIf="blogDataAvailable && selectedLanguage === 'ka'">
      <div
        class="section-header d-flex align-items-center justify-content-between"
        style="padding-top: 60px"
      >
        <h3 class="section-title" style="font-size: 24px; margin-left: 20px; padding-top: 3px">{{ "blog" | translate | uppercase}}</h3>
        <!-- <h1 class="blog-num" style="margin-left: 20px"> {{ "blog-num" | translate }} {{" " + newBlogs.length}} {{"blog-page" | translate}}</h1> -->
        <div class="d-flex align-items-center">
          <a class="seeAll" routerLink="/blog-list">{{
            "see-all" | translate
          }}</a>
          <div class="pagination"></div>
          <button class="new-prev" mat-icon-button>
            <mat-icon>west</mat-icon>
          </button>
          <button class="new-next" mat-icon-button>
            <mat-icon>east</mat-icon>
          </button>
        </div>
      </div>
      <swiper
        [breakpoints]="popularBlogConfig.breakpoints"
        [lazy]="true"
        [navigation]="popularBlogNav"
        [pagination]="popularBlogPagination"
        [preloadImages]="false"
        [spaceBetween]="24"
        class="swiper-container blog"
        style="margin-bottom:4px"
      >
        <ng-template *ngFor="let blog of newBlogs" swiperSlide>
          <app-blog-quick-view
            [blog]="blog"
            [showEllipsis]="true"
          ></app-blog-quick-view>
        </ng-template>
        <ng-template swiperSlide>
          <app-blog-quick-view
            [empty]="true"
            [showEllipsis]="true"
          ></app-blog-quick-view>
        </ng-template>
      </swiper>
      <a *ngIf="isMobile" style=" margin: 0 auto;
      width: 90%;" class="seeAllBlogsMobile" routerLink="/blog-list">{{
        "see-all" | translate
      }}</a>
    </div>

    <div class="app-block">
      <div class="row">
        <div
          class="col-lg-7 d-none d-lg-flex align-items-end"
          style="position: relative; bottom: -20px"
        >
          <img
            style="width: 342px"
            alt=""
            class="lazyload position-absolute"
            data-src="/assets/img/wooden-hand-iPhone-12-pro.png"
            loading="lazy"
          />
        </div>
        <div
          class="col-lg-5 d-flex align-items-center  justify-content-lg-start justify-content-center"
          [ngClass]="isDesktop? 'py-5' : ''"
        >
          <div>
            <h2 *ngIf="isDesktop"
              class="download-redmed-app-text text-center text-lg-left"
            >
              {{ "download-the-redmed-app" | translate | uppercase }}
            </h2>
            <h2 *ngIf="!isDesktop"
              class="download-redmed-app-text text-center text-lg-left"
              style="font-size: 18px; margin-bottom: 12px; margin-top:12px"
            >
              {{ "download-the-redmed-app" | translate | uppercase }}
            </h2>
            <div *ngIf="!isDesktop" style=" display: flex; justify-content: center;">
              <h2 
                class="download-redmed-app-text text-center text-lg-left"
                style="font-size: 14px; font-weight: 500; line-height: 30px; "
              >
                {{ "download-the-redmed-app-available" | translate }}
              </h2>
            </div>
            <h1   *ngIf="isDesktop" class="ttxt">{{"download-the-redmed-qr" | translate}}</h1>
            <img  *ngIf="isDesktop" data-src="/assets/banner-images/qr.png" class="lazyload mr-3" style="width: 108px; border-radius: 8px;" alt="qr">
            <div *ngIf="!isDesktop"
              class="d-flex stores justify-content-center justify-content-lg-start"
            >
            <div style="display: flex; flex-direction: column; width:100%">
              <div style="background-color: white; border-radius: 20px; display: flex; justify-content: center; margin-bottom: 16px">
                <a
                  href="https://apps.apple.com/us/app/redmed/id1483844703"
                  target="_blank"
                  style="width: 90%; display: flex; justify-content: center;"
                >
                  <img
                    alt=""
                    class="lazyload mr-3"
                    data-src="/assets/photos/appstore-new.png"
                    loading="lazy"
                  />
                </a>
              </div>
              <div style="background-color: white; border-radius: 20px; display: flex; justify-content: center; ">
                <a
                  href="https://play.google.com/store/apps/details?id=ge.redmed.patient"
                  target="_blank"
                >
                  <img
                    alt=""
                    class="lazyload"
                    data-src="/assets/photos/playstore-new.png"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

